<div class="player-basic-info">
  <div class="player-personal-info">

    <div class="tshirt">
      <div class="tshirt-image">
        <img src="{{player.img_url}}" alt="Player Jersey" />
      </div>
    </div>
    <div class="basic-info">
      <div class="main-info">
        <div class="name" #playerNameContainer>
          <span
            #playerNameText
            [ngClass]="{
            'text-overflow-carousel': isActiveCarousel,
            }"
          >{{ player.fullName }}
          </span>
        </div>
        <div class="position">
          <span>{{ player.position }}</span>
        </div>
      </div>
      <div class="secondary-info">
        <div class="text">
          <div class="age">
            <img src="assets/static/icons/file.svg" alt="">
            <span>{{ player.age }} años</span>
          </div>
          <div class="height">
            <img src="assets/static/icons/file.svg" alt="">
            <span>{{ player.height_in_cm }} cm</span>
          </div>
          <div class="weight">
            <img src="assets/static/icons/file.svg" alt="">
            <span>{{ player.weight_in_kg }} kg</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="child-components">
    <ng-content></ng-content>
  </div>
</div>
